// angular imports
import { 
    WritableSignal, 
    signal 
} from "@angular/core";

//local imports
import {  IBreadcrumbItemModel, ListItemFactory } from "@app/shared";
import { AbstractProgramModel } from "@app/catalog-common";
import { ProgramDto } from "@app/catalog";



export class ProgramModel extends AbstractProgramModel implements IBreadcrumbItemModel
{
    public thumbnailUrl: WritableSignal<string>;
    public canEdit: WritableSignal<boolean>;
    public canAdd: WritableSignal<boolean>;

    constructor()
    {
        super();
        this.thumbnailUrl = signal<string>(null);
        this.canEdit = signal<boolean>(false);
        this.canAdd = signal<boolean>(false);
    }

    public static fromDto(dto: ProgramDto, isChecked: boolean = false)
    {
        let program = new ProgramModel();

        program.id = dto.id;
        program.name.set(dto.name);
        program.description.set(dto.name);
        program.thumbnailUrl.set(dto.thumbnailUrl);
        program.isActive.set(dto.isActive);
        program.isChecked.set(isChecked);
        program.canEdit.set(dto.canEdit);
        program.canAdd.set(dto.canAdd);
        return program;
    }

    public toListItem = (selected: boolean = false) => 
        ListItemFactory.create<ProgramModel>(this.name, this.id, this, selected);
    

    public toListItem$ = (selected: WritableSignal<boolean>) =>
        ListItemFactory.create$<ProgramModel>(this.name, this.id, this, selected);

}
